// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M22 20H4V17H15V12H4V9H19V4L4 4V2L2 2L2 22H22V20Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-chart-column-filled')
export default class ChartColumnFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'chart-column-filled',
    }
  }
}
